// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as $$String from "@rescript/std/lib/es6/string.js";
import * as Js_string from "@rescript/std/lib/es6/js_string.js";
import * as Belt_Array from "@rescript/std/lib/es6/belt_Array.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as SearchContext$PrezzeeRibbon from "./SearchContext.bs.js";

var highlight = BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.fontWeight({
            NAME: "num",
            VAL: 700
          })]);

var Styles = {
  highlight: highlight
};

function annotateByString(input, searchTerm) {
  var sanitisedTerm = $$String.trim(Js_string.replaceByRe(/([^\w\s\d])/g, "\\$1", searchTerm));
  var re = new RegExp("(" + sanitisedTerm + ")", "gim");
  return Belt_Array.keepMapU(Js_string.splitByRe(re, input), (function (v) {
                if (v !== undefined && v !== "") {
                  return re.test(v) ? ({
                              NAME: "mark",
                              VAL: v
                            }) : ({
                              NAME: "text",
                              VAL: v
                            });
                }
                
              }));
}

function SearchBar__ListItemText(props) {
  var search = React.useContext(SearchContext$PrezzeeRibbon.context);
  var annotatedStr = annotateByString(props.text, search);
  return Belt_Array.mapWithIndex(annotatedStr, (function (idx, s) {
                if (s.NAME === "text") {
                  return JsxRuntime.jsx(React.Fragment, {
                              children: s.VAL
                            }, "txt-" + String(idx) + "");
                } else {
                  return JsxRuntime.jsx("span", {
                              children: s.VAL,
                              className: highlight
                            }, "txt-" + String(idx) + "");
                }
              }));
}

var make = SearchBar__ListItemText;

export {
  Styles ,
  annotateByString ,
  make ,
}
/* highlight Not a pure module */
